import { useDispatch, useSelector } from "react-redux";
import AllDropDownsAHSF from "../../../Components/AllDropDownsAHSF";
import DateInput from "../../../Components/DateInput";
import { useEffect, useState } from "react";
import {
  EditBI_TimelineInformation,
  GetBI_TimelineInformation,
  SetBI_TimelineInformation,
  SetValidation,
} from "../../../Redux/Reducers/BudgetInformation/TimelineInformation";
import { GetAllbI_ImplementationDurationMonths } from "../../../Redux/Reducers/DropDownApplicationInformation";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import { decryptToken } from "../../../Services/Account/EncryptionParams";

const TimeFrameInformation = () => {
  const AppGuid = useParams()
  const EditBI_TimelineInformation_ = useSelector(
    (state) => state.BI_TimelineInformation.EditBI_TimelineInformation
  );
  const [ProposedStartDateDefault, setProposedStartDateDefault] =
    useState(null);
  const [ImplementationPeriod, setImplementationPeriod] = useState(null);
  const [validationStatus, setValidationStatus] = useState(false);
  const [proposedStartDate, setProposedStartDate] = useState("");
  const [
    bI_ImplementationDurationMonthsId,
    setBI_ImplementationDurationMonthsId,
  ] = useState("");
  const [expectedEndDate, setExpectedEndDate] = useState();
  const [changeTimeMonthes, setchangeTimeMonthes] = useState(false);
  const dispatch = useDispatch();
  const state = useSelector((state) => {
    return {
      BI_TimelineInformation:
        state.BI_TimelineInformation.BI_TimelineInformation,
      BI_TimelineInformationLoding:
        state.BI_TimelineInformation.loadingBI_TimelineInformation,
      bI_ImplementationDurationMonths:
        state.dropDownApplicationInformation.bI_ImplementationDurationMonths,
      ActiveRound: state.ApplicationInformation.ActiveRound,
      ApplicationInformation:
        state.ApplicationInformation.ApplicationInformation,
    };
  });
  const validationList = useSelector(
    (state) => state.ValidationBudget?.ValidationBudgetList
  );

  const [BI_TimelineInformationData, setBI_TimelineInformationData] = useState({
    ...state.BI_TimelineInformation,
  });
//to assigin data in felds
  useEffect(() => {
    setProposedStartDateDefault(
      state.BI_TimelineInformation?.proposedStartDate
    );
    setImplementationPeriod(
      state.BI_TimelineInformation?.bI_ImplementationDurationMonthsId
    );
  }, [state.BI_TimelineInformation]);
  // Fetch initial data for implementation duration and timeline information
useEffect(() => {
  dispatch(GetAllbI_ImplementationDurationMonths()); // Fetch all possible implementation duration options
  dispatch(
    GetBI_TimelineInformation(
      localStorage.getItem("aI_ApplicationInformationId") || 
      decryptToken(AppGuid.AppGuid) // Retrieve application ID from localStorage or decrypt token
    )
  );
}, [EditBI_TimelineInformation_, changeTimeMonthes]); // Runs when either `EditBI_TimelineInformation_` or `changeTimeMonthes` changes

// Update local state with timeline information when loading completes
useEffect(() => {
  if (!state.BI_TimelineInformationLoding) { // Check if timeline information is done loading
    setBI_TimelineInformationData({ ...state.BI_TimelineInformation }); // Set the data in local state
  }
}, [state.BI_TimelineInformationLoding]); // Runs whenever loading state changes

// Update global state with local timeline information changes
useEffect(() => {
  dispatch(SetBI_TimelineInformation({ ...BI_TimelineInformationData })); // Dispatch updated timeline information to global state
}, [BI_TimelineInformationData]); // Runs whenever local timeline information data changes
//to show confirmation popup on monthes change to handel and edit if confirmed
  const DurationMonthChange = (e) => {
    Swal.fire({
      title: "  تنبيه",
      text: "هل انت متأكد من التعديل على مدة التنفيذ؟ في حال تأكيد التعديل سيتم حذف الشهور الإضافية من توزيع مساهمة شومان في موازنة التكاليف وسيتطلب إعادة التوزيع لكل بند على حدا",
      // icon: "question",
      // iconHtml: "؟",
      confirmButtonText: "تأكيد",
      cancelButtonText: "الغاء",
      showCancelButton: true,
      showCloseButton: true,
      customClass: {
        confirmButton: "sweetalertBtn",
        cancelButton: "closeBtnSweet",
      },
    }).then(async (res) => {
      //if confirmed it will change value on dropdown 
      if (res.isConfirmed == true) {
        setBI_ImplementationDurationMonthsId(parseInt(e.target.value));
        dispatch(
          EditBI_TimelineInformation({
            bI_TimelineInformationId:
              state.BI_TimelineInformation?.bI_TimelineInformationId,
            proposedStartDate: state.BI_TimelineInformation?.proposedStartDate,
            bI_ImplementationDurationMonthsId: e.target.value,
            expectedEndDate: state.BI_TimelineInformation?.expectedEndDate,
            aI_ApplicationInformationId: localStorage.getItem(
              "aI_ApplicationInformationId"
            ),
          })
        );
       //if isDismissed it will do nothing
      } else if (res.isDismissed == true) {
        setBI_ImplementationDurationMonthsId(
          state.BI_TimelineInformation?.bI_ImplementationDurationMonthsId
        );
        if (!changeTimeMonthes) {
          setchangeTimeMonthes(true);
        } else {
          setchangeTimeMonthes(false);
        }
      }
    });
  };

  const shouldDisableFields = !(
   //[,]
// مابقدر يعدل اذا ماكانت الدورة فعالة او managerالحالة قيد المراجة او الدخول من ال
state.ActiveRound ==
      state.ApplicationInformation?.aI_RoundYearId &&
    state.ApplicationInformation?.aI_ApplicationStatus?.canEdite &&
    window.location.href.includes("manager") == false
  );
  const validation = () => {};

  
  let validationList2 =
    validationList &&
    validationList.map((ele) => {
      return ele.code;
    });
    //after loding ends render html
  return !state.BI_TimelineInformationLoding ? (
    <>
      <div className="form-grid">
        <DateInput
          fieldsName="ProposedStartDate"
          date={state.BI_TimelineInformation?.proposedStartDate}
          onChange={(e) => {
            const adjustedDate = new Date(
              Date.UTC(e.getFullYear(), e.getMonth(), e.getDate())
            );
            setProposedStartDate(adjustedDate);
            // //console.log(e,"eeeeeeeeeeeeeeeeeeeeeeeeeee");
            setBI_TimelineInformationData({
              ...BI_TimelineInformationData,
              proposedStartDate: adjustedDate,
            });
            setProposedStartDateDefault(adjustedDate);
            if (
              state.BI_TimelineInformation?.bI_ImplementationDurationMonthsId
            ) {
              dispatch(
                EditBI_TimelineInformation({
                  bI_TimelineInformationId:
                    state.BI_TimelineInformation?.bI_TimelineInformationId,
                  proposedStartDate: adjustedDate,
                  bI_ImplementationDurationMonthsId:
                    state.BI_TimelineInformation
                      ?.bI_ImplementationDurationMonthsId,
                  expectedEndDate:
                    state.BI_TimelineInformation?.expectedEndDate,
                  aI_ApplicationInformationId: localStorage.getItem(
                    "aI_ApplicationInformationId"
                  ),
                })
              );
            }
          }}
          minDate={new Date(2026, 0, 1)}
          showValidationMessage={
            validationList2 && validationList2.includes("ProposedStartDate")
          }
          validationMessage="يرجى تعبئة هذا الحقل"
          disabled={shouldDisableFields}
          filterDate={true}
        />
        <AllDropDownsAHSF
          fieldsName="ImplementationPeriod"
          show={true}
          disabled={shouldDisableFields}
          dropdownType="normal"
          arrayOoptionList={state.bI_ImplementationDurationMonths}
          KeyText={"implementationDurationMonths"}
          KeyValue={"bI_ImplementationDurationMonthsId"}
          defaultValue={
            state.BI_TimelineInformation?.bI_ImplementationDurationMonthsId
          }
          onChange={(e) => {
            setImplementationPeriod(e);
            DurationMonthChange(e);
          }}
          showValidationMessage={
            validationList2 && validationList2.includes("ImplementationPeriod")
          }
          validationMessage="يرجى تعبئة هذا الحقل"
        />
        <DateInput
          fieldsName="ExpectedEndDate"
          list=""
          date={state.BI_TimelineInformation?.expectedEndDate}
          disabled={true}
          onChange={(e) => {
            setExpectedEndDate(e);
            dispatch(
              EditBI_TimelineInformation({
                bI_TimelineInformationId:
                  state.BI_TimelineInformation?.bI_TimelineInformationId,
                proposedStartDate:
                  state.BI_TimelineInformation?.proposedStartDate,
                bI_ImplementationDurationMonthsId:
                  state.BI_TimelineInformation
                    ?.bI_ImplementationDurationMonthsId,
                expectedEndDate: e,
                aI_ApplicationInformationId: localStorage.getItem(
                  "aI_ApplicationInformationId"
                ),
              })
            );
          }}
        />
      </div>
    </>
  ) : (
    ""
  );
};

export default TimeFrameInformation;
